import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GetLocalStorage, LocalStorageKeyName } from '@/util/local-storage';

export function ReturnToGame() {
    const { t } = useTranslation();
    const storedId = GetLocalStorage(LocalStorageKeyName.GameId);

    if (storedId) {
        return (
            <div className="text-center">
                <Link to={`/game/${storedId}`} className="underline">
                    ← {t('howToPlay.btnReturnToGame')} <span className="font-mono">{storedId.toString()}</span>
                </Link>
            </div>
        );
    } else {
        return null;
    }
}
